import React, { memo } from 'react';

const Group = memo(({
  group,
  isSelected,
  onSelect,
  onDoubleClick,
  onMouseDown,
  onResize
}) => {
  const { id, x, y, width, height, label, color = '#e5e7eb' } = group;

  const handleClick = (e) => {
    e.stopPropagation();
    onSelect?.(id, e.shiftKey);
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    onDoubleClick?.(id);
  };

  const handleMouseDown = (e) => {
    if (e.button !== 0) return;
    e.stopPropagation();
    onMouseDown?.(e, id, x, y);
  };

  // Resize handles
  const handleResizeMouseDown = (e, corner) => {
    e.stopPropagation();
    onResize?.(e, id, corner);
  };

  return (
    <g
      transform={`translate(${x}, ${y})`}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      onMouseDown={handleMouseDown}
      style={{ cursor: 'move' }}
      className="group-container"
    >
      {/* Background */}
      <rect
        x={0}
        y={0}
        width={width}
        height={height}
        fill={color}
        fillOpacity={0.15}
        stroke={isSelected ? '#3b82f6' : color}
        strokeWidth={isSelected ? 2 : 1}
        strokeDasharray={isSelected ? 'none' : '4,4'}
        rx={8}
        ry={8}
      />

      {/* Header bar */}
      <rect
        x={0}
        y={0}
        width={width}
        height={32}
        fill={color}
        fillOpacity={0.3}
        rx={8}
        ry={8}
      />
      <rect
        x={0}
        y={16}
        width={width}
        height={16}
        fill={color}
        fillOpacity={0.3}
      />

      {/* Label */}
      <text
        x={12}
        y={21}
        fontSize="13"
        fontWeight="600"
        fill="#374151"
        pointerEvents="none"
      >
        {label || 'Group'}
      </text>

      {/* Selection indicators */}
      {isSelected && (
        <>
          {/* Corner resize handles */}
          <rect
            x={-4}
            y={-4}
            width={8}
            height={8}
            fill="#3b82f6"
            stroke="#fff"
            strokeWidth={1}
            rx={2}
            style={{ cursor: 'nwse-resize' }}
            onMouseDown={(e) => handleResizeMouseDown(e, 'nw')}
          />
          <rect
            x={width - 4}
            y={-4}
            width={8}
            height={8}
            fill="#3b82f6"
            stroke="#fff"
            strokeWidth={1}
            rx={2}
            style={{ cursor: 'nesw-resize' }}
            onMouseDown={(e) => handleResizeMouseDown(e, 'ne')}
          />
          <rect
            x={-4}
            y={height - 4}
            width={8}
            height={8}
            fill="#3b82f6"
            stroke="#fff"
            strokeWidth={1}
            rx={2}
            style={{ cursor: 'nesw-resize' }}
            onMouseDown={(e) => handleResizeMouseDown(e, 'sw')}
          />
          <rect
            x={width - 4}
            y={height - 4}
            width={8}
            height={8}
            fill="#3b82f6"
            stroke="#fff"
            strokeWidth={1}
            rx={2}
            style={{ cursor: 'nwse-resize' }}
            onMouseDown={(e) => handleResizeMouseDown(e, 'se')}
          />
        </>
      )}
    </g>
  );
});

Group.displayName = 'Group';

export default Group;
